/**
 * DOM event target helpers shared by keyboard-driven demo surfaces.
 *
 * SPDX-License-Identifier: LicenseRef-Proprietary
 * Copyright (c) 2026 Invariant Holdings LLC
 */

export function isEditableElementTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  const tag = target.tagName;
  const { isContentEditable } = target as unknown as {
    readonly isContentEditable?: boolean;
  };
  return (
    tag === "INPUT" ||
    tag === "TEXTAREA" ||
    tag === "SELECT" ||
    (isContentEditable ?? false)
  );
}
